import { gql } from "@apollo/client";

export const REPLACE_CREW_MEMBER_ON_ASSIGNMENT = gql`
    mutation replaceCrewMemberOnAssignment($assignment: Int!, $newCrewMember: Int!) {
        replaceCrewMemberOnAssignment(assignment: $assignment, newCrewMember: $newCrewMember) {
            crewMemberAssignment {
                id
            }
        }
    }
`